import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isGeoMotionVideo, isMaps } from '../../../modules/checkDeployEnv';

import LinkContainer from '../../containers/LinkContainer';

const { isTierra2 } = Meteor.settings.public;

const DashboardButton = ({ deployEnv }) => {
  if (isGeoMotionVideo(deployEnv)) {
    return (
      <LinkContainer to="/dashboard">
        <Nav.Link>
          <FontAwesomeIcon icon="globe" /> Dashboard
        </Nav.Link>
      </LinkContainer>
    );
  }
  return '';
};

const AtlasButton = ({ deployEnv }) => {
  if (isMaps(deployEnv) && isTierra2) {
    return (
      <LinkContainer exact to="/atlas">
        <Nav.Link>
          <FontAwesomeIcon icon="atlas" /> Atlas
        </Nav.Link>
      </LinkContainer>
    );
  }
  return '';
};

const PublicNavigation = ({ deployEnv }) => (
  <>
    <Nav className="mr-auto">
      <AtlasButton deployEnv={deployEnv} />
      <DashboardButton deployEnv={deployEnv} />
    </Nav>
    <Nav>
      <LinkContainer to="/signup">
        <Nav.Link>Sign Up</Nav.Link>
      </LinkContainer>
      <LinkContainer to="/login">
        <Nav.Link>Log In</Nav.Link>
      </LinkContainer>
    </Nav>
  </>
);

PublicNavigation.propTypes = {
  deployEnv: PropTypes.string.isRequired
};

export default PublicNavigation;
